import { render, staticRenderFns } from "./MessageBubble.vue?vue&type=template&id=78f5d0d0&scoped=true"
import script from "./MessageBubble.vue?vue&type=script&lang=js"
export * from "./MessageBubble.vue?vue&type=script&lang=js"
import style0 from "./MessageBubble.vue?vue&type=style&index=0&id=78f5d0d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f5d0d0",
  null
  
)

export default component.exports